import { Component } from '@angular/core'

import { LeaseDetailService } from '../../data/services/view/lease-detail.service'

/**
 * ADR-0021 — Render dinámico de la Calculadora (scoring de riesgo).
 *
 * Itera `calculatorData.pillars[]`. Las 5 keys son estables (character, capacity,
 * capital, collateral, aditional) pero los labels y rows internos son dinámicos
 * del Excel.
 */
@Component({
	selector: 'app-lease-calculator',
	templateUrl: './lease-calculator.component.html',
	styleUrls: ['./lease-calculator.component.scss'],
})
export class LeaseCalculatorComponent {
	constructor(public leaseDetailService: LeaseDetailService) {}

	get calculator(): any {
		return this.leaseDetailService.calculatorData
	}

	get pillars(): any[] {
		const c = this.calculator
		return Array.isArray(c?.pillars) ? c.pillars : []
	}

	get hasData(): boolean {
		return this.pillars.length > 0
	}

	get isApproved(): boolean {
		const d = String(this.calculator?.decision || '').toLowerCase()
		return d === 'aceptado' || d === 'aprobado' || d === 'approved'
	}

	get isRejected(): boolean {
		const d = String(this.calculator?.decision || '').toLowerCase()
		return d === 'rechazado' || d === 'rejected'
	}

	trackByPillarKey(_idx: number, p: any): string {
		return p.key
	}

	trackByRowIndex(_idx: number, r: any): number {
		return r.rowIndex
	}

	/** Tag de PrimeNG según la decisión final del scoring. */
	get decisionSeverity(): 'success' | 'danger' | 'warning' {
		if (this.isApproved) return 'success'
		if (this.isRejected) return 'danger'
		return 'warning'
	}

	get decisionLabel(): string {
		return this.calculator?.decision || 'Pendiente'
	}

	/** Porcentaje 0-100 del puntaje sobre la escala teórica (100). */
	get scoreProgress(): number {
		const score = Number(this.calculator?.totalScore)
		if (!Number.isFinite(score)) return 0
		return Math.min(100, Math.max(0, score))
	}

	/** Posición del umbral en el progress bar como porcentaje 0-100. */
	get thresholdProgress(): number {
		const t = Number(this.calculator?.acceptanceThreshold)
		if (!Number.isFinite(t)) return 60
		return Math.min(100, Math.max(0, t))
	}

	/**
	 * Diferencia entre puntaje y umbral.
	 *  > 0: aprobado por X pts
	 *  < 0: faltaron |X| pts
	 *  null: sin datos
	 */
	get pointsDifference(): number | null {
		const score = Number(this.calculator?.totalScore)
		const threshold = Number(this.calculator?.acceptanceThreshold)
		if (!Number.isFinite(score) || !Number.isFinite(threshold)) return null
		return score - threshold
	}

	/** Icono FontAwesome por key de pilar. */
	iconForPillar(key: string): string {
		switch (key) {
			case 'character': return 'fa-solid fa-user-tie'
			case 'capacity':  return 'fa-solid fa-chart-line'
			case 'capital':   return 'fa-solid fa-coins'
			case 'collateral':return 'fa-solid fa-shield-halved'
			case 'aditional': return 'fa-solid fa-circle-plus'
			default:          return 'fa-solid fa-square-poll-vertical'
		}
	}
}
